import React from 'react';
import { View, Text } from 'react-native';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';

export default ({ C, symbol }) => {
  return (
    <View>
      <View style={{ height: scale(60), justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
        <Text style={[font['Headline'], { color: C('Label/Light/Tertiary') }]}>{symbol}</Text>
      </View>
      <View
        style={{
          marginTop: scale(76),
          height: scale(33),
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>{symbol}</Text>
      </View>
    </View>
  );
};
